// Masuk (/masuk), the public sign-in. One card in a centered 400px column
// (design review ui.region_gate login_google: card, the runner-up, since the
// plain-spacing primary repeats the brand region next to it):
//   brand   card head (product name h1, purpose line)
//   status  the expired-session notice, when a session just ended
//   action  the Google sign-in choices (shell/GoogleSignIn): Lanjutkan dengan
//           Google (a real account) and Masuk mode simulasi (the simulated
//           dialog); each appears when GET /auth/google/config reports its mode
//   help    one muted line on what happens after, and a way back to the guest chat
// No password form and no link to the password sign-in: that lives at /portal,
// which no public page links to.
import { googleErrorMessage, safeNextPath } from "../lib/account";
import { PRODUCT_NAME } from "../lib/product";
import { useLocation } from "../router";
import { ThemeToggle } from "../shell/ThemeToggle";
import { GoogleButton } from "../shell/GoogleSignIn";
import { Notice, useTitle } from "../ui/components";
import { Glyph } from "../ui/icons";

export function LoginScreen({ expired = false }: { expired?: boolean }) {
  useTitle("Masuk");
  const loc = useLocation();
  const failure = googleErrorMessage(loc.query.get("error"));
  const next = safeNextPath(loc.query.get("next"));
  return (
    <main id="main" className="login" data-ui-shell="none" data-jal-shell="none">
      <div className="login-column">
        <section className="card login-card" aria-labelledby="login-title">
          <header className="login-head">
            <div className="login-head-text">
              <h1 id="login-title" className="login-title">
                {PRODUCT_NAME}
              </h1>
              <p className="login-lead">Masuk untuk menyimpan riwayat percakapan, membuat project, dan menyusun dokumen pengadaan bersama Pluto.</p>
            </div>
          </header>

          <div className="login-body">
            {expired ? (
              <Notice tone="info" title="Sesi Anda berakhir" className="login-notice">
                <p>Silakan masuk kembali untuk melanjutkan pekerjaan Anda.</p>
              </Notice>
            ) : null}
            {failure ? (
              <Notice tone="danger" title="Belum bisa masuk" className="login-notice">
                <p>{failure}</p>
              </Notice>
            ) : null}
            <GoogleButton block next={next} />
            <a className="btn btn-secondary btn-block" href="/">
              Coba sebagai tamu
            </a>
            <p className="login-help">
              <Glyph name="infoCircle" />
              <span>Akun baru diminta menyetujui ketentuan penggunaan dan memilih jenis akun sebelum mulai.</span>
            </p>
          </div>
        </section>
        <div className="login-tools">
          <ThemeToggle />
        </div>
      </div>
    </main>
  );
}
